import React from 'react';
import AboutOverviewPage from './AboutOverviewPage';
import { ABOUT_OVERVIEW_V2 } from './aboutOverviewDataV2';

const AboutV2 = () => (
  <AboutOverviewPage
    data={ABOUT_OVERVIEW_V2}
    versionLink={{ to: '/about', label: '← View Version 1.0.0' }}
  />
);

export default AboutV2;
